export const flightReservedSeatRequestType: any = {
  none: "Not request",
  request_only_free: "Request only if it is free",
  request_with_fee: "Request with fee",
};
